/* Winnie's Picks — mobile drawer: merge/rename hubs + exclusive accordion (+ keep-in-view) + base Featured tile */
(function () {
  function firstText(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n.textContent.trim();
    }
    return el.textContent.trim();
  }
  function setLabel(summary, label) {
    for (var i = 0; i < summary.childNodes.length; i++) {
      var n = summary.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = label; return; }
    }
    summary.insertBefore(document.createTextNode(label), summary.firstChild);
  }
  function findHub(scope, name) {
    var sums = scope.querySelectorAll('summary.menu-drawer__menu-item');
    for (var i = 0; i < sums.length; i++) {
      if (firstText(sums[i]) === name) return sums[i].parentElement;
    }
    return null;
  }
  function innerUl(details) {
    return details.querySelector('.menu-drawer__inner-submenu > ul.menu-drawer__menu') ||
           details.querySelector('.menu-drawer__submenu ul.menu-drawer__menu');
  }
  function mergeHub(scope, targetName, sourceName, newLabel) {
    var t = findHub(scope, targetName);
    var s = findHub(scope, sourceName);
    if (!t || !s) return;
    var tul = innerUl(t), sul = innerUl(s);
    if (tul && sul) { while (sul.firstElementChild) { tul.appendChild(sul.firstElementChild); } }
    if (newLabel) setLabel(t.querySelector('summary'), newLabel);
    if (s.parentElement) s.parentElement.remove();
  }
  function renameHub(scope, name, newLabel) {
    var h = findHub(scope, name);
    if (h) setLabel(h.querySelector('summary'), newLabel);
  }

  function enhance() {
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!nav || nav.dataset.wpEnhanced) return;
    nav.dataset.wpEnhanced = '1';

    /* 1) mobile-only regrouping */
    mergeHub(nav, 'By Difficulty', 'By Format', 'Formats & Levels');
    mergeHub(nav, 'Flowers', 'Styles', 'Flowers & Styles');
    renameHub(nav, 'Artists & Famous', 'Famous Artists');

    /* keep a natural order: Flowers & Styles before Famous Artists */
    var fs = findHub(nav, 'Flowers & Styles');
    var fa = findHub(nav, 'Famous Artists');
    if (fs && fa && fs.parentElement && fa.parentElement) {
      fs.parentElement.parentNode.insertBefore(fa.parentElement, fs.parentElement.nextSibling);
    }

    /* 2) native <details> accordion: strip theme drill-down handlers */
    var summaries = nav.querySelectorAll('summary');
    for (var i = 0; i < summaries.length; i++) {
      summaries[i].replaceWith(summaries[i].cloneNode(true));
    }

    /* 3) exclusive accordion + keep the just-opened group in view */
    var allDetails = nav.querySelectorAll('details');
    for (var j = 0; j < allDetails.length; j++) {
      allDetails[j].addEventListener('toggle', function () {
        if (!this.open) return;
        var ul = this.parentElement && this.parentElement.parentElement;
        if (ul) {
          var lis = ul.children;
          for (var k = 0; k < lis.length; k++) {
            var d = lis[k].querySelector ? lis[k].querySelector(':scope > details') : null;
            if (d && d !== this && d.open) d.open = false;
          }
        }
        var self = this;
        if (window.requestAnimationFrame) {
          requestAnimationFrame(function () {
            var s = self.querySelector('summary');
            if (s && s.scrollIntoView) s.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          });
        }
      });
    }

    /* 4) compact Featured tile (with CTA) at the base menu level */
    var topUl = nav.querySelector(':scope > ul.menu-drawer__menu');
    if (topUl && !topUl.querySelector('.menu-drawer__featured')) {
      var li = document.createElement('li');
      li.className = 'menu-drawer__featured-item';
      li.innerHTML =
        '<a href="/products/custom-photo-paint-by-numbers" class="menu-drawer__featured">' +
        '<span class="menu-drawer__featured-title">Custom from your photo</span>' +
        '<span class="menu-drawer__featured-sub">Up to 48 colors &middot; 450+ &#9733; reviews</span>' +
        '<span class="menu-drawer__featured-cta">Create yours &rarr;</span>' +
        '</a>';
      topUl.appendChild(li);
    }
  }
  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', enhance);
})();
